// extracted by mini-css-extract-plugin
export var menuIcon = "_r5-0";
export var menuIconInline = "_r5-1";